var render, staticRenderFns
import script from "./barReactive.vue?vue&type=script&lang=js&"
export * from "./barReactive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19baf1b4",
  null
  
)

export default component.exports